<template>
  <v-card outlined @click="goTo">
    <v-card-title>
      <span>{{ title }}</span>
      <v-spacer />
      <v-icon color="blue3">{{ addressIcon }}</v-icon>
    </v-card-title>
    <v-card-subtitle>
      <div>{{ address.line1 }} <span v-if="address.line2 !== ''">{{ address.line2 }}</span></div>
      <div v-if="address.line3 !== ''">{{ address.line3 }}</div>
      <div v-if="address.line4 !== ''">{{ address.line4 }}</div>
      <div>
        <span>{{ address.city }}</span>
        <span>
          <span v-if="address.city && address.city !== ''">, </span>{{ address.state }}</span>
          <span> {{ address.zipCode }}</span>
      </div>
      <div>
        {{ countryAbbr[address.country] }}
      </div>
    </v-card-subtitle>
  </v-card>
</template>

<style>
</style>

<script>
import analyticsService from '@/services/shared/analyticsService.js';

export default {
  name: 'Address',
  props: {
    address: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      hover: false,
      addressTypes: {
        0: 'Other',
        1: 'Billing',
        2: 'Mailing',
        3: 'Physical',
        4: 'Garaging',
        5: 'Property'
      },
      countryAbbr: {
        0: 'U',
        1: 'US',
        2: 'CA',
        3: 'MX',
        4: 'UK',
        5: 'AF',
        6: 'AL',
        7: 'AG',
        8: 'AN',
        9: 'AO',
        10: 'AV',
        11: 'AY',
        12: 'AR',
        13: 'AM',
        14: 'AA',
        15: 'AS',
        16: 'AU',
        17: 'AJ',
        18: 'BF',
        19: 'BA',
        20: 'BG',
        21: 'BB',
        22: 'BO',
        23: 'BE',
        24: 'BH',
        25: 'BN',
        26: 'BD',
        27: 'BT',
        28: 'BL',
        29: 'BC',
        30: 'BR',
        31: 'BX',
        32: 'BU',
        33: 'UV',
        34: 'BM',
        35: 'BY',
        36: 'CB',
        37: 'CM',
        38: 'CV',
        39: 'CJ',
        40: 'CD',
        41: 'CI',
        42: 'CH',
        44: 'CO',
        45: 'CN',
        46: 'CF',
        47: 'CG',
        48: 'CW',
        49: 'CS',
        50: 'HR',
        51: 'CY',
        52: 'EZ',
        53: 'DA',
        54: 'DJ',
        55: 'DO',
        56: 'DR',
        57: 'EC',
        58: 'EG',
        59: 'ES',
        60: 'EK',
        61: 'ER',
        62: 'EN',
        63: 'ET',
        64: 'FJ',
        65: 'FI',
        66: 'FR',
        67: 'FG',
        68: 'FP',
        69: 'GB',
        70: 'GA',
        71: 'GG',
        72: 'GM',
        73: 'GH',
        74: 'GI',
        75: 'GR',
        76: 'GL',
        77: 'GJ',
        78: 'GP',
        79: 'GT',
        80: 'GK',
        81: 'GV',
        82: 'PU',
        83: 'GY',
        84: 'HA',
        85: 'HO',
        86: 'HK',
        87: 'HU',
        88: 'IC',
        89: 'IN',
        90: 'ID',
        91: 'EI',
        92: 'IS',
        93: 'IT',
        94: 'IV',
        95: 'JM',
        96: 'JN',
        97: 'JA',
        98: 'JE',
        99: 'JO',
        100: 'KZ',
        101: 'KE',
        102: 'KR',
        103: 'KS',
        104: 'KU',
        105: 'KG',
        106: 'LA',
        107: 'LG',
        108: 'LE',
        109: 'LS',
        110: 'LH',
        111: 'LU',
        112: 'MC',
        113: 'MK',
        114: 'MA',
        115: 'MI',
        116: 'MY',
        117: 'MV',
        118: 'ML',
        119: 'MT',
        120: 'MB',
        121: 'MR',
        122: 'MP',
        123: 'MF',
        124: 'MD',
        125: 'MN',
        126: 'MG',
        127: 'MJ',
        128: 'MH',
        129: 'MO',
        130: 'MZ',
        131: 'WA',
        132: 'NR',
        133: 'NP',
        134: 'NL',
        135: 'NT',
        136: 'NC',
        137: 'NZ',
        138: 'NU',
        139: 'NG',
        140: 'NI',
        141: 'NE',
        142: 'NO',
        143: 'MU',
        144: 'PK',
        145: 'PM',
        146: 'PP',
        147: 'PA',
        148: 'PE',
        149: 'RP',
        150: 'PL',
        151: 'PO',
        152: 'QA',
        153: 'RO',
        154: 'RS',
        155: 'RW',
        156: 'SH',
        157: 'ST',
        158: 'WS',
        159: 'SM',
        160: 'SA',
        161: 'SG',
        162: 'RB',
        163: 'SE',
        164: 'SL',
        165: 'SN',
        166: 'LO',
        167: 'SI',
        168: 'BP',
        169: 'SO',
        170: 'SF',
        171: 'SP',
        172: 'CE',
        173: 'SU',
        174: 'NS',
        175: 'SV',
        176: 'WZ',
        177: 'SW',
        178: 'SZ',
        179: 'SY',
        180: 'TW',
        181: 'TI',
        182: 'TZ',
        183: 'TH',
        184: 'TO',
        185: 'TN',
        186: 'TD',
        187: 'TS',
        188: 'TU',
        189: 'TX',
        190: 'TV',
        191: 'UG',
        192: 'UP',
        193: 'AE',
        194: 'UY',
        195: 'UZ',
        196: 'NH',
        197: 'VT',
        198: 'VE',
        199: 'VM',
        200: 'VI',
        201: 'WF',
        202: 'WI',
        203: 'YM',
        204: 'ZA',
        205: 'ZI'
      }
    };
  },
  computed: {
    addressIcon: function () {
      switch (this.address.addressType) {
        case 1:
          return 'mdi-currency-usd';
        case 2:
          return 'mdi-mailbox-open-outline';
        default:
          return 'mdi-home';
      }
    },
    title: function () {
      if (this.address.addressType <= 5) {
        return `${this.addressTypes[this.address.addressType]} Address`;
      } else return 'Address';
    }
  },
  methods: {
    goTo: function () {
      analyticsService.sendEvent(this.$gtag, 'Map', 'Client', 'Client Info Map');
      var baseUrl = 'https://www.google.com/maps/place/';
      var locationUrl = '';

      if ((this.address.line1 || null) !== null) {
        var split = this.address.line1.split(' ');
        for (var i = 0; i < split.length; i++) {
          if (i === 0) locationUrl += split[i];
          else locationUrl += `+${split[i]}`;
        }
      }

      if ((this.address.city || null) !== null) {
        if (locationUrl === '') locationUrl += this.address.city;
        else locationUrl += `+${this.address.city}`;
      }

      if ((this.address.state || null) !== null) {
        if (locationUrl === '') locationUrl += this.address.state;
        else locationUrl += `+${this.address.state}`;
      }

      if ((this.address.country || null) !== null) {
        if (locationUrl === '') locationUrl += this.countryAbbr[this.address.country];
        else locationUrl += `+${this.countryAbbr[this.address.country]}`;
      }

      if ((this.address.zipCode || null) !== null) {
        if (locationUrl === '') locationUrl += this.address.zipCode;
        else locationUrl += `+${this.address.zipCode}`;
      }

      window.open(`${baseUrl}${locationUrl}`, '_blank');
    }
  }
};
</script>
